import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import Constraint from 'js/components/Constraint';
import Modal from 'js/components/core/Modal';

import Title from 'js/components/core/SteppedPage/Title';
import SubTitle from 'js/components/core/SteppedPage/SubTitle';
import StepStatus from 'js/components/core/SteppedPage/StepStatus';
import ProgressRow from 'js/components/core/SteppedPage/ProgressRow';
import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';
import Backdrop from 'js/components/core/Backdrop';
import AddButton, { buttonHeight } from 'js/components/core/SteppedPage/AddButton';

import Form from './Form';
import Display from './Display';

@inject('page')
@observer
export default class PickupDetails extends Component {
  meetInPerson = () => this.props.page.setDelivery('in-person').nextStep();

  render() {
    const page = this.props.page;
    const showDisplay = page.address.hasAddress;
    const contentOffset = showDisplay ? `2.5rem` : `${buttonHeight / 2}rem`;

    return (
      <>
        <Backdrop offset={contentOffset}>
          <Constraint>
            <Title>Delivery address</Title>
            <SubTitle>Your address is private and only shared with the delivery service.</SubTitle>
          </Constraint>
        </Backdrop>

        <Constraint offset={contentOffset}>
          {showDisplay ? (
            <Display />
          ) : (
            <AddButton autoFocus onClick={page.openModal}>
              Add a delivery address
            </AddButton>
          )}
          <ProgressRow>
            <ContinueButton autoFocus={showDisplay} onClick={page.nextStep}>
              Continue
            </ContinueButton>
            <StepStatus />
          </ProgressRow>
        </Constraint>

        <Modal showModal={page.modalIsVisible} onCancel={page.closeModal} withCloseButton>
          <Form />
        </Modal>
      </>
    );
  }
}
